export const steps_tour_guide_chat_bot = [
    {
        target: "#chatbot-toggle-button",
        title: "Voici notre Chatbot IA",
        content: (
            <span>
                Cliquez ici pour discuter avec notre assistant virtuel IA qui
                peut vous aider à naviguer et répondre à vos questions.
            </span>
        ),
        disableBeacon: true,
        placement: "top",
        spotlightPadding: 10,
    },
];
